import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserResponse, FitnessConsumerProfile, FitnessConsumerProfileResponse } from '../models';
import { ApplicationChecker } from '@fitscovery/common/classes/application-checker';

import { Guid } from '@fitscovery/common/types';
import { SignOutRevokeUserToken } from '@fitscovery/auth/data-access';
import { VendorAdminResponse } from '@fitscovery/partner/data-access';
import { APP_ENVIRONMENT } from '../environment-injection';
import { WINDOW } from '@ng-web-apis/common';
import { Environment } from '@fitscovery/common/environments';

@Injectable()
export class ApiUserService extends ApplicationChecker {

  constructor(
    private http: HttpClient,
    private store: Store,
    @Inject(APP_ENVIRONMENT) private env: Environment,
    @Inject(WINDOW) public override window: any
  ) {
    super(window)
  }

  getCurrentUser(): Observable<UserResponse> {
    return <any>this.http.get(`${this.env.azureFunctionsApi.users}/users/firebase/current-user`).pipe(
      catchError((response: HttpErrorResponse) => this.errorResponseCatch(response))
    );
  }

  getUserPartners(userId: Guid): Observable<VendorAdminResponse> {
    return <any>this.http.get(`${this.env.azureFunctionsApi.users}/users/${userId}/partners`).pipe(
      catchError((response: HttpErrorResponse) => this.errorResponseCatch(response)),
    );
  }

  getFitnessConsumerProfileByUserId(userId: Guid): Observable<FitnessConsumerProfileResponse> {
    return <any>this.http.get(`${this.env.azureFunctionsApi.users}/users/${userId}/fitness-consumer-profile`).pipe(
      catchError((response: HttpErrorResponse) => this.errorResponseCatch(response)),
    );
  }

  updateFitnessConsumerProfile(profile: FitnessConsumerProfile): Observable<FitnessConsumerProfileResponse> {
    return <Observable<FitnessConsumerProfileResponse>>this.http.put(`${this.env.azureFunctionsApi.users}/users/${profile.userId}/fitness-consumer-profile`, profile);
  }

  private errorResponseCatch(response: HttpErrorResponse): any {
    if (response.status === 400 && this.isAdminWeb) {
      this.window.location.hash = "no-vendor";
      this.store.dispatch(new SignOutRevokeUserToken);
    }
    throw new Error(response.error?.errors[0]);
  }

}
